import React, { useState } from 'react';
import '../../styles/Auth.css'; 
const PasswordInput = ({ label, value, onChange, name, placeholder }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="password-wrapper">
      {label && <label htmlFor={name}>{label}</label>}
      <input
        type={showPassword ? 'text' : 'password'}
        name={name}
        id={name}
        className="auth-input"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      <span
        className="password-toggle"
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? '👁️' : '🙈'}
      </span>
    </div>
  );
};

export default PasswordInput;
